<template>
  <div class="card" v-if="result.name || result.country || result.type || result.remarks">
    <div class="card-header">Other Information</div>

    <div class="card-body">
      <template
        v-if="result.remarks && result.remarks.length === 1 && result.remarks[0].title === 'remarks'"
      >
        <table class="table">
          <tbody>
            <tr>
              <td>
                <p v-html="parseDescription(result.remarks[0].description)"></p>
              </td>
            </tr>
          </tbody>
        </table>
      </template>

      <template v-else>
        <table class="table">
          <tbody>
            <template v-if="result.name">
              <tr>
                <th scope="row" width="120px">Name</th>
                <td>{{result.name}}</td>
              </tr>
            </template>

            <template v-if="result.country">
              <tr>
                <th scope="row" width="120px">Country</th>
                <td>{{result.country}}</td>
              </tr>
            </template>

            <template v-if="result.type">
              <tr>
                <th scope="row" width="120px">Status</th>
                <td>{{result.type}}</td>
              </tr>
            </template>

            <template v-if="result.remarks">
              <template v-for="remark in result.remarks">
                <tr v-if="remark.title === 'description' && remark.description" :key="remark.title">
                  <th scope="row" width="120px">Description</th>
                  <td v-html="parseDescription(remark.description)">{{result.remarks}}</td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
      </template>
    </div>
  </div>
</template>

<script>
export default {
	props: ["result"],
	methods: {
		parseDescription(array) {
			if (array.length > 0) {
				// const desc = array[0].description;
				const result = array.join("<br>");
				return result;
			}
			return "";
		}
	}
};
</script>

<style scoped lang="scss">
tbody tr:first-child {
	th,
	td {
		border-top: none;
	}
}
</style>
